export const SEGMENT_SET_TRAITS = 'SEGMENT_SET_TRAITS'
